import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Help18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_589)'>
      <path
        d='M9.44345 5.74145C8.6641 5.71146 7.99653 6.35673 8.00002 7.13665L6.50003 7.14336C6.49277 5.5218 7.88076 4.1802 9.50113 4.24256C11.1215 4.30491 12.4023 5.74921 12.2704 7.36542C12.1867 8.39225 11.5226 9.33578 10.5855 9.76158C10.1152 10.0316 10.14 10.5314 10.14 11H8.64003C8.64003 10.4211 8.65534 9.87123 8.95188 9.35056C9.43544 8.50152 10.6881 8.31372 10.7754 7.24345C10.8388 6.46627 10.2153 5.77115 9.44345 5.74145Z'
        fill='currentColor'
      />
      <path
        d='M10.3901 13C10.3901 13.5523 9.94242 14 9.39014 14C8.83785 14 8.39014 13.5523 8.39014 13C8.39014 12.4477 8.83785 12 9.39014 12C9.94242 12 10.3901 12.4477 10.3901 13Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8.26836 0.848088C10.6929 0.469439 13.2112 1.22375 15.0314 2.86878C16.8549 4.51677 17.8609 6.95029 17.74 9.40449L17.739 9.42044C17.5877 11.5634 16.6262 13.5679 15.0506 15.0235C13.476 16.4781 11.407 17.2746 9.26637 17.2494H1.00002C0.34661 17.2494 0.00752756 16.4331 0.468657 15.9701L2.75964 13.6702C1.1893 11.3782 0.881381 8.37346 1.95208 5.8096C3.04354 3.19602 5.46835 1.28517 8.26836 0.848088ZM8.49976 2.33013C6.21027 2.6875 4.22858 4.25085 3.33623 6.38764C2.44232 8.52816 2.72384 11.0412 4.07193 12.9294C4.439 13.4319 4.38955 14.147 3.95646 14.594L3.94921 14.6015L2.80568 15.7494H9.2801C11.038 15.7711 12.7382 15.1176 14.0327 13.9217C15.3253 12.7276 16.1158 11.0828 16.2422 9.32272C16.3386 7.31696 15.516 5.32852 14.0256 3.98164C12.5383 2.63749 10.481 2.02071 8.49976 2.33013Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_589'>
        <rect width='18' height='18' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

Help18.displayName = 'Help18';
export default Help18;
